export const KEEPLIVE_ROUTE_SWITCH = 'KEEPLIVE_ROUTE_SWITCH'

export const KEEPLIVE_ROUTE_COMPONENT = 'KEEPLIVE_ROUTE_COMPONENT'

export const ACITON_CREATED    = 'created'       /* 缓存创建 */
export const ACTION_ACTIVE     = 'active'        /* 缓存激活 */
export const ACTION_ACTIVED    = 'actived'       /* 激活完成 */
export const ACITON_UNACTIVE   = 'unActive'      /* 缓存休眠 */
export const ACTION_UNACTIVED  = 'unActived'     /* 休眠完成 */
export const ACTION_RESERT     = 'reset'         /* 设置摧毁状态 */
export const ACTION_DESTORYED  = 'destoryed'     /* 摧毁缓存 */
export const ACTION_CLEAR      = 'clear'         /* 清除缓存 */